module.exports = __webpack_public_path__ + "static/media/ICON-BEAUTY_CARE.78ef9100.svg";